import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MainFundContentComponent } from './main-fund-content/main-fund-content.component';
import { OverviewEntryComponent } from './overview-entry/overview-entry.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@shared/shared.module';
import { FundTabsComponent } from "@products/overview/fund-tabs/fund-tabs.component";
import { FundHeaderComponent } from './fund-header/fund-header.component';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    SharedModule,
    SlickCarouselModule,
    NgbPaginationModule,
    NgCircleProgressModule.forRoot({
      backgroundGradient: true,
      radius: 35,
      showZeroOuterStroke: true,
      space: -7,
      outerStrokeGradient: true,
      outerStrokeWidth: 7,
      innerStrokeWidth: 5,
      outerStrokeColor: "#583EE7",
      animateTitle: false,
      outerStrokeGradientStopColor: "#00B6AE",
      innerStrokeColor: "#fff",
      animationDuration: 300,
      animation: false,
      showUnits: true,
      unitsColor: "#00847D",
      unitsFontSize: "18",
      titleFontSize: "18",
      titleColor: "#00847D",
      showBackground: false,
      clockwise: true,
      startFromZero: true,
      showSubtitle: false,
      lazy: false,
      responsive: true,
      renderOnClick: true
    })
  ],
  declarations: [
    OverviewEntryComponent,
    MainFundContentComponent,
    FundTabsComponent,
    FundHeaderComponent,
  ],
  entryComponents: [OverviewEntryComponent],
})
export class OverviewModule {
}

export const overviewModuleComponentMapping = {
  'IND Fund Content': OverviewEntryComponent,
};
